var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _circle2, _ellipse, _circle3, _ellipse2, _circle4, _circle5, _circle6, _circle7, _circle8, _ellipse3, _circle9, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m493.103 402.188 60.511 63.553 23.28-38.799 38.799-23.279L567.178 354",
    fill: "#E1E4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m493.103 402.188 60.511 63.553 23.28-38.799 38.799-23.279L567.178 354",
    stroke: "#E1E4E5",
    strokeWidth: 7.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m406.945 402.188-60.511 63.553-23.279-38.799-38.799-23.279L332.87 354",
    fill: "#E1E4E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m406.945 402.188-60.511 63.553-23.279-38.799-38.799-23.279L332.87 354",
    stroke: "#E1E4E5",
    strokeWidth: 7.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m459.213 135.273 22.503-11.003c10.383-5.075 22.938-1.009 28.355 9.218l11.748 22.131a21.478 21.478 0 0 0 15.24 11.066l24.677 4.33c11.391 2.002 19.135 12.664 17.521 24.117l-3.507 24.8a21.432 21.432 0 0 0 5.82 17.91l17.413 18.003c8.039 8.303 8.039 21.495 0 29.813l-17.413 18.003a21.431 21.431 0 0 0-5.82 17.909l3.507 24.801c1.614 11.453-6.13 22.115-17.521 24.117l-24.677 4.33a21.478 21.478 0 0 0-15.24 11.066l-11.748 22.131c-5.417 10.212-17.956 14.293-28.355 9.218l-22.503-11.003a21.44 21.44 0 0 0-18.825 0l-22.504 11.003c-10.382 5.075-22.938 1.009-28.354-9.218l-11.749-22.147a21.475 21.475 0 0 0-15.24-11.065l-24.676-4.33c-11.391-2.002-19.136-12.664-17.522-24.118l3.508-24.8a21.433 21.433 0 0 0-5.82-17.91l-17.413-18.002c-8.039-8.303-8.039-21.495 0-29.814l17.413-18.002a21.433 21.433 0 0 0 5.82-17.91l-3.492-24.8c-1.63-11.438 6.13-22.116 17.522-24.102l24.676-4.33a21.48 21.48 0 0 0 15.224-11.066l11.749-22.131c5.416-10.212 17.956-14.293 28.354-9.218l22.504 11.003a21.44 21.44 0 0 0 18.825 0z",
    fill: "#facc15",
    stroke: "#facc15",
    strokeWidth: 7.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450.126,
    cy: 271.486,
    r: 94.141,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m448.861 304.647 24.218 12.722c4.716 2.479 10.228-1.523 9.325-6.779l-4.622-26.967 19.595-19.082c3.814-3.72 1.711-10.202-3.558-10.97l-27.074-3.935-12.102-24.541c-2.359-4.784-9.164-4.784-11.523 0l-12.102 24.541-27.087 3.948c-5.27.768-7.372 7.251-3.558 10.97l19.595 19.083-4.623 26.966c-.903 5.256 4.609 9.259 9.326 6.779l24.217-12.722h-.027v-.013z",
    fill: "#facc15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M663.695 359.523c-14.841 3.515-30.537-9.071-30.537-9.071s8.376-18.279 23.222-21.784c14.841-3.516 30.532 9.059 30.532 9.059s-8.376 18.28-23.217 21.796z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.479 166.891c19.546 13.463 49.407 4.052 49.407 4.052s-1.849-31.236-21.408-44.686c-19.546-13.463-49.394-4.065-49.394-4.065s1.849 31.236 21.395 44.699z",
    fill: "url(#b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.954 177.643c-13.483 13.723-38.695 10.829-38.695 10.829s-3.336-25.142 10.159-38.856c13.482-13.722 38.682-10.837 38.682-10.837s3.336 25.142-10.146 38.864z",
    fill: "url(#c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.071,
    cy: 477.267,
    r: 11.584,
    transform: "rotate(180 239.071 477.267)",
    fill: "#facc15"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.378,
    cy: 472.081,
    rx: 12.826,
    ry: 12.185,
    transform: "rotate(180 605.378 472.081)",
    fill: "#facc15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 11.516,
    transform: "matrix(-1 0 0 1 202.646 243.282)",
    fill: "#facc15"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.544,
    ry: 10.902,
    transform: "matrix(-1 0 0 1 604.095 132.99)",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 9.267,
    transform: "matrix(-1 0 0 1 398.914 510.841)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5.535,
    transform: "matrix(-1 0 0 1 504.86 507.109)",
    fill: "#E1E4E5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 7.907,
    transform: "matrix(-1 0 0 1 533.378 94.83)",
    fill: "#E1E4E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 7.726,
    transform: "scale(1 -1) rotate(-75 -75.225 -517.466)",
    fill: "#E1E4E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 10.279,
    transform: "matrix(-1 0 0 1 188.247 327.594)",
    fill: "#E1E4E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.907,
    ry: 6.325,
    transform: "matrix(-1 0 0 1 276.496 298.498)",
    fill: "#E1E4E5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 16.08,
    transform: "scale(1 -1) rotate(-75 57.215 -687.592)",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.868 359.784h.207c1.225 17.354 14.131 17.622 14.131 17.622s-14.231.277-14.231 20.33c0-20.053-14.232-20.33-14.232-20.33s12.901-.268 14.125-17.622zM347.707 80h.202c1.196 17.656 13.802 17.928 13.802 17.928s-13.9.282-13.9 20.684c0-20.402-13.901-20.684-13.901-20.684s12.601-.272 13.797-17.928zm-200.91 299.526h.202c1.196 17.656 13.801 17.928 13.801 17.928s-13.9.283-13.9 20.684c0-20.401-13.9-20.684-13.9-20.684s12.6-.272 13.797-17.928zm513.638-127.584h.202c1.197 17.656 13.802 17.928 13.802 17.928s-13.9.283-13.9 20.684c0-20.401-13.9-20.684-13.9-20.684s12.6-.272 13.796-17.928zm96.073 22.293h.151c.894 13.192 10.312 13.395 10.312 13.395s-10.386.212-10.386 15.455c0-15.243-10.385-15.455-10.385-15.455s9.414-.203 10.308-13.395z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 607.808,
    y1: 368.264,
    x2: 737.725,
    y2: 306.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 300.619,
    y1: 211.065,
    x2: 146.758,
    y2: 48.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 661.161,
    y1: 224.516,
    x2: 758.632,
    y2: 71.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.297f95eb9496c014c001b1dcb7fc2d9e.svg";
export { ForwardRef as ReactComponent };